import { render } from "./MediaItem.vue?vue&type=template&id=56437885&ts=true"
import script from "./MediaItem.vue?vue&type=script&lang=ts"
export * from "./MediaItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__